import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import ReportActions from '../actions/ReportActions';

const ReportSource = {
    getReports() {
        return {
            remote(state, shiftId) {
                const query = '?shift__id=' + shiftId;
                return new SingleObjectResource(DJ_CONST.API.reportList + query).fetch();
            },

            success: ReportActions.getReportsSuccess,
            error: ReportActions.getReportsFail
        }
    },
};

class ReportStore {
    constructor() {
        this.reports = [];
        this.reportsReceived = false;

        this.exportAsync(ReportSource);
        this.bindActions(ReportActions);
    }

    onGetReportsSuccess(reports) {
        this.setState({reports, reportsReceived: true});
    }

    onClearReports() {
        this.setState({reports: [], reportsReceived: false});
    }
}

export default createStore(ReportStore, 'ReportStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/ReportStore.js
 **/